import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { CustomerInfo, CustomerType, DialogBase, RentalInfo } from 't4core';
import { RentalCustomerDetails } from '../../components/RentalCustomerDetails/RentalCustomerDetails';
import { DialogService } from '../../services/dialog.service';


@Component({
  selector: 't4-CustomerDialog',
  templateUrl: 'CustomerDialog.html',
  styleUrls: ['./CustomerDialog.css']
})
export class CustomerDialog extends DialogBase implements OnInit {
  public customerId: number;
  public customer: CustomerInfo;
  public customerType = CustomerType;
  public rentals: RentalInfo[];
  public invoiceRentals: RentalInfo[];
  public clientSettingsForm: any = this.Settings.clientSettings.CustomerSettings;
  public actionType: string = 'existing';
  public blockedForm: FormGroup;
  private validatedCustomerNumber: string | null = null;
  isLoading: boolean = false;

  @ViewChild("frmCustomerInfo", { static: false }) public frmCustomerInfo: RentalCustomerDetails;


  // Form for customer information
  @ViewChild("txtSSN", { static: false }) public txtSSN: NgModel;
  @ViewChild("txtFirstname", { static: false }) public txtFirstname: NgModel;
  @ViewChild("txtLastname", { static: false }) public txtLastname: NgModel;
  @ViewChild("txtAddress", { static: false }) public txtAddress: NgModel;
  @ViewChild("txtZipCode", { static: false }) public txtZipCode: NgModel;
  @ViewChild("txtCity", { static: false }) public txtCity: NgModel;
  @ViewChild("txtMobilePhone", { static: false }) public txtMobilePhone: NgModel;
  @ViewChild("txtEmail", { static: false }) public txtEmail: NgModel;
  @ViewChild("txtCompanyName", { static: false }) public txtCompanyName: NgModel;
  @ViewChild("txtComments", { static: false }) public txtComments: NgModel;
  @ViewChild("chkBlockCustomer", { static: false }) public chkBlockCustomer: ElementRef;


  @ViewChild('customerTabs', { static: false }) customerTabs: MatTabGroup;
  @ViewChild('reasonTextArea', { static: false }) reasonTextArea: ElementRef;


  public isSaved: boolean = false;
  isCustomerChanged: boolean = false;
  rentalsLoaded: boolean = false;
  invoiceRentalsLoaded: boolean = false;
  isCustomerValidated: boolean = true;
  isvalidCustomerNumber: boolean = true;

  constructor(public dialogRef: MatDialogRef<CustomerDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private dialogSvc: DialogService, private fb: FormBuilder) {
    super("CustomerDialog");

    if (data.object) {
      this.customer = data.object;
      this.customerId = this.customer.Id;
      this.actionType = data.actionType;
    } else {
      this.customerId = data.objectId;
      this.actionType = data.actionType;
    }
  }

  async ngOnInit() {
    if (this.actionType == 'existing') {
      this.isLoading = true;

      await this.loadCustomer();
      this.loadCustomerHistory();

      if (this.customer && this.customer.Type == CustomerType.Company) {
        this.loadCustomerInvoiceHistory();
      }

      this.blockedForm = this.fb.group({
        Blocked: [this.customer.Blocked || false],
        BlockedReason: [{ value: this.customer.BlockedReason || "", disabled: !this.customer.Blocked }, Validators.required]
      });

      this.blockedForm.get('Blocked').valueChanges.subscribe((blocked) => {
        if (blocked) {
          this.blockedForm.get('BlockedReason').enable();
        } else {
          this.blockedForm.get('BlockedReason').disable();
        }
      });

      this.isLoading = false;
    }
  }

  private async loadCustomer() {
    this.customer = await this.Api.get<CustomerInfo>("/Rental/GetCustomerInfo", { customerId: this.customerId });
    if (this.customer && ((this.customer.AllowInvoicing && this.customer.CustomerNumber && this.customer.CustomerNumber != '') || (!this.customer.AllowInvoicing && (!this.customer.CustomerNumber || this.customer.CustomerNumber == '')))) {
      this.isCustomerValidated = true;
      this.validatedCustomerNumber = this.customer.CustomerNumber;
      this.isvalidCustomerNumber = true;
    }
  }

  private async loadCustomerHistory() {
    this.loading.isLoading = true;
    this.rentals = await this.Api.get<RentalInfo[]>("/Rental/GetCustomerRentals", { customerId: this.customerId });
    this.loading.isLoading = false;
    this.rentalsLoaded = true;
  }
  private async loadCustomerInvoiceHistory() {
    this.loading.isLoading = true;
    this.invoiceRentals = await this.Api.get<RentalInfo[]>("/Rental/GetCustomerInvoiceRentals", { customerId: this.customerId });
    this.loading.isLoading = false;
    this.invoiceRentalsLoaded = true;
  }

  public regenerateCode() {
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    this.customer.InvoiceCode = `AC${randomDigits}${randomLetter}`;
  }

  public async validateCustomerNumber() {
    this.loading.isLoading = true;
    this.isvalidCustomerNumber = await this.Api.get<boolean>("/Rental/ValidateCustomerNumber", { customerNumber: this.customer.CustomerNumber });
    this.loading.isLoading = false;
    if (this.isvalidCustomerNumber) {
      this.isCustomerValidated = true;
      this.validatedCustomerNumber = this.customer.CustomerNumber;
      this.regenerateCode();
    }
    else {
      this.isCustomerValidated = false;
    }
  }

  onCustomerNumberChange(): void {
    if (!this.validatedCustomerNumber) {
      this.isCustomerValidated = false;
      return;
    }

    this.isCustomerValidated = this.customer.CustomerNumber === this.validatedCustomerNumber;
  }

  public static async open(dialog: MatDialog, obj: CustomerInfo, id: number = null, actionType: string = 'existing'): Promise<boolean> {
    return dialog.open(CustomerDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      height: "750px",
      width: "750px",
      data: {
        object: obj,
        objectId: id,
        actionType: actionType
      }
    }).afterClosed().toPromise();
  }

  public blockCustomer(chkBlockCustomer: any) {
    this.isCustomerChanged = true;
    if (chkBlockCustomer.checked) {
      this.customer.Blocked = true;
    }
    else {
      this.customer.Blocked = false;
    }
  }

  public changePaymentType(ListchangePaymentType: any) {
    this.isCustomerChanged = true;
    if (ListchangePaymentType == 0) {
      this.customer.Payment = 0;

    }
    else {
      this.customer.Payment = 0;

    }
  }

  // <Validation>
  public changeCustomerType(t: CustomerType) {
    if (this.customer.Type == t) return;

    this.customer.Type = t;
    this.isCustomerChanged = true;
  }
  public async validateSSN() {
    if (this.txtSSN.invalid || this.txtSSN.pristine) return;
  }

  public async save(forceClose: boolean = false): Promise<Boolean> {
    // === Customer === ///
    var customer = new CustomerInfo();
    customer.Type = this.customer.Type;

    if (!this.frmCustomerInfo.validate()) return false;

    var customerChanged = false;

    if (this.frmCustomerInfo.dirty()) {
      this.frmCustomerInfo.markAllAsTouched();
      customer = this.frmCustomerInfo.customer;
      customer.Id = this.customerId;
      customerChanged = true;
    }

    if (!this.blockedForm.pristine && this.blockedForm.valid) {

      customer.Blocked = this.blockedForm.get('Blocked').value;
      if (customer.Blocked == false) customer.BlockedReason = ""
      else customer.BlockedReason = this.blockedForm.get('BlockedReason').value;

      this.isCustomerChanged = true;
    }

    customer.AllowInvoicing = this.customer.AllowInvoicing;
    customer.InvoiceCode = this.customer.InvoiceCode;
    customer.CustomerNumber = this.customer.CustomerNumber;

    ////Set changed settings
    if (this.isCustomerChanged) { customerChanged = true; }
    customer.Payment = this.customer.Payment;
    //customer.Blocked = this.customer.Blocked;
    customer.Type = this.customer.Type;

    // Set id
    // if (this.customer.Id) { customer.Id = this.customer.Id; }

    // Save customer
    if (customerChanged) {
      var cToken = this.beginLoad("Turbo.Core.Dialogs.CustomerDialog.ldrSaveCustomer", "Updating customer info...", null);
      var y = await this.Api.post<boolean>("/Rental/EditCustomerInfo", customer);
      if (y == false) {
        this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.UpdateCustomer.Failed.Headline", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.UpdateCustomer.Failed.Message", "The customer information could not be updated.");
        return;
      }


      this.frmCustomerInfo.markFormPristine();
      this.blockedForm.markAsPristine();


      this.endLoad(cToken);

      if (forceClose) this.dialogRef.close();

      this.dialogRef.close(true);
      return true;
    }

  }

  public async createCustomer(): Promise<Boolean> {

    var customer = new CustomerInfo();
    customer.Type = this.customer.Type;

    if (!this.frmCustomerInfo.validate()) return false;

    var customerChanged = false;

    if (this.frmCustomerInfo.dirty()) {
      this.frmCustomerInfo.markAllAsTouched();
      customer = this.frmCustomerInfo.customer;
      customerChanged = true;
    }

    if (this.isCustomerChanged) { customerChanged = true; }
    customer.Payment = this.customer.Payment;
    customer.Type = this.customer.Type;

    // Save customer
    if (customerChanged) {
      var cToken = this.beginLoad("Turbo.Core.Dialogs.CustomerDialog.ldrSaveCustomer", "Saving customer info...", null);
      var y = await this.Api.post<CustomerInfo>("/Rental/SaveCustomer", customer, { isOneWay: false });
      if (y == null) {
        this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.UpdateCustomer.Failed.Headline", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.UpdateCustomer.Failed.Message", "The customer information could not be saved.");
        return;
      }

      this.customer = y;
      this.customerId = this.customer.Id;
      this.actionType = 'existing';
      this.loadCustomerHistory();

      if (this.customer && this.customer.Type == CustomerType.Company) {
        this.loadCustomerInvoiceHistory();
      }

      if (this.customer && this.customer.CustomerNumber && this.customer.CustomerNumber != '') {
        this.isCustomerValidated = true;
        this.validatedCustomerNumber = this.customer.CustomerNumber;
      }

      this.blockedForm = this.fb.group({
        Blocked: [this.customer.Blocked || false],
        BlockedReason: [{ value: this.customer.BlockedReason || "", disabled: !this.customer.Blocked }, Validators.required]
      });

      this.blockedForm.get('Blocked').valueChanges.subscribe((blocked) => {
        if (blocked) {
          this.blockedForm.get('BlockedReason').enable();
        } else {
          this.blockedForm.get('BlockedReason').disable();
        }
      });

      this.frmCustomerInfo.markFormPristine();
      this.blockedForm.markAsPristine();
      this.endLoad(cToken);
      return true;
    }
  }

  public blockCustomerClick() {
    this.customerTabs.selectedIndex = 1;
    this.blockedForm.get('Blocked').setValue(true);

    setTimeout(() => {
      this.reasonTextArea.nativeElement.focus();
    }, 10);

  }

  public async deletePersonalInfo() {
    if (this.rentalsLoaded) {
      for (let rental of this.rentals) {
        if (rental.Status == 0 || rental.Status == 100 || rental.Status == 150) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.NotAllowed.Headline", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.NotAllowed.Message", "The customer has active rentals.");
          return;
        }
      }
    }
    else {
      return;
    }
    this.UI.confirm("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirm.Headline", "Are you sure that you want to delete this customer?", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirm.Message", "The customer data will be deleted permanently.", null, null).then(async y => {
      if (!y) { return; }
      else {
        var cToken = this.beginLoad("Turbo.Core.Dialogs.CustomerDialog.ldrDeleteCustomer", "Removing customer from the database...", null);
        var success = await this.Api.post<CustomerDeletionResponse>("/Customer/DeleteCustomerDataIfEligible", this.customer);

        this.endLoad(cToken);

        if (success == 0) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineOK", "Success!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessegeOK", "The customer has been deleted.");
          this.dialogRef.close();
        }
        else if (success == 1) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineInvalidInputAdyen", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageInvalidInputAdyen", "Unable to delete from Adyen.");
        }
        else if (success == 2) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineNoUser", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageNoUser", "There is no customer with provided Id.");
        }
        else if (success == 3) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlinePendingBooking", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessagePendingBooking", "The customer have a pending booking, Unable to delete.");
        }
        else if (success == 4) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineRecentBooking", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageRecentBooking", "The customer have a recent booking that was made in the past 30 days.");
        }
        else if (success == 5) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineUnauthorized", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageUnauthorized", "We dont have access to this customer.");
        }
        else if (success == 6) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineDeletedFromT4", "Sucess!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageDeletedFromT4", "The customer have been deleted from T4, but no info found in Adyen");
        }
        else if (success == 7) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineAlreadyProcessed", "Sucess!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageAlreadyProcessed", "The customer have been deleted from T4, and is already in queue to be deleted in Adyen.");
        }
        else if (success == 8) {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.HeadlineSubscriptionExists", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.MessageUnauthorized", "This customer have a ongoing Subscription, unable to delete.");
        }

        else {
          this.UI.alert("Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.Failed", "Failed!", "Turbo.Core.Dialogs.CustomerDialog.DeleteCustomer.Confirmed.Message", "The customer could not be deleted. Try again.");
        }
      }
    });
  }
}

export enum CustomerDeletionResponse {
  OK = 0,
  InvalidInput = 1,
  NoUser = 2,
  PendingBooking = 3,
  RecentBooking = 4,
  Unauthorized = 5,
  DeletedFromT4_NotFoundPayment = 6,
  AlreadyProcessed = 7,
  SubscriptionExists = 8,
}
